import { AlertColorType } from "@/lib/main";
import { OutlineAlertIconNameType } from "@/lib/types/graphics/icons/IconName.type";

const useSwitchAlertIcon = (
  alertColor: AlertColorType
): OutlineAlertIconNameType => {
  switch (alertColor) {
    case "assist":
      return "info-circle";
    case "danger":
      return "error-circle";
    case "info":
      return "info-circle";
    case "success":
      return "check-circle";
    case "warning":
      return "warning";
    default:
      return "info-circle";
  }
};

export default useSwitchAlertIcon;
